import { render, staticRenderFns } from "./error-dialog.vue?vue&type=template&id=b075b952"
import script from "./error-dialog.vue?vue&type=script&lang=ts"
export * from "./error-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports